import { render, staticRenderFns } from "./ClimateRecap.vue?vue&type=template&id=590410a0&"
import script from "./ClimateRecap.vue?vue&type=script&lang=ts&"
export * from "./ClimateRecap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports